import gql from 'graphql-tag';

export const link = gql`
  fragment ToolLinkListItem on Channel {
    id
    # Needed for Apollo caching
    slug
    name
    # Apparently the channel slug is the url...
    url: slug
  }
`;
